import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/home/Home.vue";
import Service from "../components/service/Service.vue";
import About from "../components/About.vue";
import Booking from "../components/booking/Booking.vue";
import selectDate from "../components/selectDate/date.vue";
import Payment from "../components/payment/payment.vue";
import Contact from "../components/contact/contact.vue";
import serviceCategoryPage from "../components/serviceCategory/ServiceCategoryPage.vue";
import aboutUs from "../components/aboutUs/about.vue";
import backHome from "../components/backHome/backHome.vue";
import thankYou from "../components/thankYou/thankYou.vue";
import privacy from "../components/privacy/privacy.vue";
import termsCondition from "../components/termsCondition/termsCondition.vue";
import refundPolicy from "../components/refundPolicy/refundPolicy.vue";
import blog from "../components/blog/blog.vue";
import blogDetail from "../components/blogDetail/blogDetail.vue";
import ApplyPartnerPage from "../components/applyPartner/ApplyPartnerPage.vue";
import ApplySalonJoinPage from "../components/applyPartner/ApplySalonJoinPage.vue";
import ApplyJoinThankYou from "../components/applyPartner/ApplyJoinThankYou.vue";
import SalonDashboard from "../components/dashboard/SalonDashboard.vue";
import GroomerDashboard from "../components/dashboard/GroomerDashboard.vue";
import UserDashboard from "../components/dashboard/UserDashboard.vue";
import PartnerDashboardProfile from "../components/dashboard/PartnerDashboardProfile.vue";
import PartnerDashboardLocation from "../components/dashboard/PartnerDashboardLocation.vue";
import PartnerDashboardAvailability from "../components/dashboard/PartnerDashboardAvailability.vue";
import PartnerAppointmentsPage from "../components/dashboard/PartnerAppointmentsPage.vue";
import PartnerEarningsPage from "../components/dashboard/PartnerEarningsPage.vue";
import PartnerDashboardSettings from "../components/dashboard/PartnerDashboardSettings.vue";
import SetPartnerPassword from "../components/applyPartner/SetPartnerPassword.vue";
import PartnerPublicLoginRedirect from "../components/applyPartner/PartnerPublicLoginRedirect.vue";
import PartnerLoginPage from "../components/applyPartner/PartnerLoginPage.vue";
import { readCountrySlugFromStorage, readDefaultCountrySlugFromStorage, setCurrentCountrySlug } from "@/utils/currentCountry";
import { readCountryNameFromStorage } from "@/utils/currentCountry";
import { PARTNER_PUBLIC_LOGIN_URL } from "@/utils/partnerPublicLoginUrl";

// const routes = [
//   { path: "/", component: Home },
//   { path: "/service", component: Service },
//   { path: "/about", component: About },
//   { path: "/booking", component: Booking },
//   { path: "/date", component: selectDate },
//   { path: "/payment", component: Payment },
//   { path: "/contact", component: Contact },
//   { path: "/dogGrooming", component: dogGrooming },
//   { path: "/catGrooming", component: catGrooming },
//   { path: "/aboutUs", component: aboutUs },
//   { path: "/backHome", component: backHome },
//    { path: "/birdsGrooming", component: birdsGrooming },
//   { path: "/rabbitGrooming", component: rabbitGrooming },
// ];

// const router = createRouter({
//   history: createWebHistory(), // Make sure you're using history mode
//   routes,
// });

// export default router;

const baseRoutes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/services/",
    component: Service,
    meta: {
      title: "Book Mobile pet grooming services in dubai",
      description: "Are you a pet owner and searching for best grooming services in Dubai? Visit Dubai Pet Groomer for affordable and premium grooming services, offering royal care for pets of all kinds.",
    },
  },
  {
    path: "/about",
    component: About,
    meta: {
      title: "About Us - Lush Groom",
      description: "Dubai Pet Groomer offers premium mobile pet grooming services across Dubai. We provide professional, convenient, and affordable grooming for pets of all sizes, right at your door!",
    },
  },
  {
    path: "/blog/",
    component: blog,
    meta: {
      title: "Get Latest Info About Pet Grooming - Lush Groom",
      description: "Dubai Pet Groomer is the place where you can learn all about pet grooming and how to keep your pet healthy and safe.",
    },
  },
  {
    path: '/blog/:slug',
    component: blogDetail,
    meta: {
      title: "Get Latest Info About Pet Grooming - Lush Groom",
      description: "Dubai Pet Groomer is the place where you can learn all about pet grooming and how to keep your pet healthy and safe.",
    },
  },
  {
    path: "/booking/",
    component: Booking,
    meta: {
      title: "Book Professional Mobile Pet Groomer at Reasonable price",
      description: "Book a professional mobile pet groomer in Dubai at a reasonable price! Enjoy high-quality grooming services for your pet, delivered right to your doorstep.",
    },
  },
  {
    path: "/date",
    component: selectDate,
    meta: {
      noindex: true
    },
  },
  {
    path: "/payment",
    component: Payment,
    meta: {
      title: "Return and Refund Policy - Lush Groom",
      description: "Thank you for choosing Lush Groom. We strive to provide the highest quality grooming services to all of our clients and their beloved pets. ",
    },
  },
  {
    path: "/contact-us",
    component: Contact,
    meta: {
      title: "Contact Us - Lush Groom",
      description: "Get in touch with Dubai Pet Groomer for best mobile pet grooming services in Dubai. Book an appointment today and have your pet groomed at your doorstep!",
    },
  },
  {
    path: "/services/:slug/",
    name: "serviceCategory",
    component: serviceCategoryPage,
    meta: {
      title: "Pet Grooming Service",
      description: "Professional mobile pet grooming services tailored to your pet.",
    },
  },
  {
    path: "/about-us",
    component: aboutUs,
    meta: {
      title: "About Us - Lush Groom",
      description: "Dubai Pet Groomer offers premium mobile pet grooming services across Dubai. We provide professional, convenient, and affordable grooming for pets of all sizes, right at your door!",
    },
  },
  {
    path: "/apply-as-groomer",
    component: ApplyPartnerPage,
    meta: {
      title: "Apply as Groomer - Lush Groom",
      description: "Apply to join Lush Groom as a professional mobile pet groomer in Dubai.",
      pageHeading: "Apply as Groomer",
    },
  },
  {
    path: "/apply-as-salon",
    component: ApplyPartnerPage,
    meta: {
      title: "Apply as Salon - Lush Groom",
      description: "Apply to partner with Lush Groom as a salon in Dubai.",
      pageHeading: "Apply as Salon",
    },
  },
  {
    path: "/apply-as-salon/join",
    component: ApplySalonJoinPage,
    meta: {
      title: "Join LushGroom as a Salon - Lush Groom",
      description: "Join Lush Groom as a salon partner.",
      pageHeading: "Join LushGroom",
      noindex: true,
    },
  },
  {
    path: "/apply/join/thank-you",
    name: "applyJoinThankYou",
    component: ApplyJoinThankYou,
    meta: {
      title: "Thank You - Lush Groom",
      description: "Your application has been submitted.",
      noindex: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: PartnerLoginPage,
    meta: {
      title: "Login - Lush Groom",
      description: "Login as a user, salon, or groomer.",
      noindex: true,
    },
  },
  {
    path: "/partner-login",
    redirect: "/login",
    meta: { noindex: true },
  },
  // Backend (or admin host) can redirect here after set-password; browser then opens public login.
  {
    path: "/partner-login-redirect",
    name: "partnerPublicLoginRedirect",
    component: PartnerPublicLoginRedirect,
    meta: {
      title: "Redirecting - Lush Groom",
      description: "Redirect to partner login.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon",
    name: "salonDashboard",
    component: SalonDashboard,
    meta: {
      title: "Salon Dashboard - Lush Groom",
      description: "Salon partner dashboard.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/profile",
    name: "salonDashboardProfile",
    component: PartnerDashboardProfile,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Profile - Lush Groom",
      description: "Salon partner profile.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/availability",
    name: "salonDashboardAvailability",
    component: PartnerDashboardAvailability,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Availability - Lush Groom",
      description: "Salon partner availability.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/location",
    name: "salonDashboardLocation",
    component: PartnerDashboardLocation,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Location - Lush Groom",
      description: "Salon partner location.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/appointments",
    name: "salonDashboardAppointments",
    component: PartnerAppointmentsPage,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Appointments - Lush Groom",
      description: "Bookings assigned to your salon.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/earnings",
    name: "salonDashboardEarnings",
    component: PartnerEarningsPage,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Earnings - Lush Groom",
      description: "Completed bookings and earnings.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/salon/settings",
    name: "salonDashboardSettings",
    component: PartnerDashboardSettings,
    props: { partnerRole: "salon" },
    meta: {
      title: "Salon Settings - Lush Groom",
      description: "Partner account settings.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer",
    name: "groomerDashboard",
    component: GroomerDashboard,
    meta: {
      title: "Groomer Dashboard - Lush Groom",
      description: "Groomer partner dashboard.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/profile",
    name: "groomerDashboardProfile",
    component: PartnerDashboardProfile,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Profile - Lush Groom",
      description: "Groomer partner profile.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/availability",
    name: "groomerDashboardAvailability",
    component: PartnerDashboardAvailability,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Availability - Lush Groom",
      description: "Groomer partner availability.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/location",
    name: "groomerDashboardLocation",
    component: PartnerDashboardLocation,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Location - Lush Groom",
      description: "Groomer partner location.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/appointments",
    name: "groomerDashboardAppointments",
    component: PartnerAppointmentsPage,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Appointments - Lush Groom",
      description: "Bookings assigned to you as a groomer.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/earnings",
    name: "groomerDashboardEarnings",
    component: PartnerEarningsPage,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Earnings - Lush Groom",
      description: "Completed bookings and earnings.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/groomer/settings",
    name: "groomerDashboardSettings",
    component: PartnerDashboardSettings,
    props: { partnerRole: "groomer" },
    meta: {
      title: "Groomer Settings - Lush Groom",
      description: "Partner account settings.",
      noindex: true,
    },
  },
  {
    path: "/dashboard/user",
    name: "userDashboard",
    component: UserDashboard,
    meta: {
      title: "User Dashboard - Lush Groom",
      description: "User dashboard.",
      noindex: true,
    },
  },
  {
    path: "/set-password/:token",
    name: "setPartnerPassword",
    component: SetPartnerPassword,
    meta: {
      title: "Set Password - Lush Groom",
      description: "Set your password to access your dashboard.",
      noindex: true,
    },
  },
  {
    path: "/backHome",
    component: backHome,
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/booking/thank-you",
    name: "thankYou",
    component: thankYou,
    props: route => ({
      customerName: route.query.customerName
    }),
    meta: {
      title: "Get The Best Mobile Pet Grooming Service In Dubai",
      description: "Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.",
    },
  },
  {
    path: "/privacy",
    component: privacy,
    meta: {
      title: "Privacy Policy - Lush Groom",
      description: "At Lush Groom, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information",
    },
  },
  {
    path: "/termsCondition",
    component: termsCondition,
    meta: {
      title: "terms condition text",
      description: "terms condition content",
    },
  },
  {
    path: "/refundPolicy",
    component: refundPolicy,
    meta: {
      title: "Return and Refund Policy - Lush Groom",
      description: "Thank you for choosing Lush Groom. We strive to provide the highest quality grooming services to all of our clients and their beloved pets.",
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: Home,
    meta: {
      title: "Page Not Found",
      description: "The page you're looking for doesn't exist.",
      noindex: true,
    },
  },
];

// Country prefix (domain/{slug}/...). Keep un-constrained to avoid route mismatches.
const COUNTRY_PARAM = ":countrySlug";

const SERVICE_CATEGORY_PATH = "/services/:slug/";

// Register /:country/services/:slug BEFORE other prefixed routes so it beats the prefixed catch-all.
const countryPrefixedServiceCategoryMeta = {
  title: "Pet Grooming Service",
  description: "Professional mobile pet grooming services tailored to your pet.",
};

const countryPrefixedServiceCategoryRoutes = [
  {
    path: `/${COUNTRY_PARAM}/services/:slug/`,
    component: serviceCategoryPage,
    meta: countryPrefixedServiceCategoryMeta,
  },
  {
    path: `/${COUNTRY_PARAM}/services/:slug`,
    component: serviceCategoryPage,
    meta: countryPrefixedServiceCategoryMeta,
  },
];

const baseRoutesForCountryPrefix = baseRoutes.filter((r) => r.path !== SERVICE_CATEGORY_PATH);

const prefixedRoutes = baseRoutesForCountryPrefix.map((r) => {
  if (r.path === "/") {
    return { ...r, path: `/${COUNTRY_PARAM}/` };
  }
  if (r.path.startsWith("/:pathMatch")) {
    return { ...r, path: `/${COUNTRY_PARAM}/:pathMatch(.*)*` };
  }
  const pathNoLeadingSlash = r.path.startsWith("/") ? r.path.slice(1) : r.path;
  return { ...r, path: `/${COUNTRY_PARAM}/${pathNoLeadingSlash}` };
});

// IMPORTANT: put the country-prefixed catch-all AFTER base routes,
// otherwise single-segment paths like `/login` get interpreted as `/:countrySlug`.
const prefixedCatchAll = prefixedRoutes.find((r) => String(r.path).includes(':pathMatch')) || null;
const prefixedNonCatchAll = prefixedCatchAll
  ? prefixedRoutes.filter((r) => r !== prefixedCatchAll)
  : prefixedRoutes;

const routes = [
  ...countryPrefixedServiceCategoryRoutes,
  ...prefixedNonCatchAll,
  ...baseRoutes,
  ...(prefixedCatchAll ? [prefixedCatchAll] : []),
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  strict: false,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
});

// Partner login lives on the public site; if this SPA is served from admin, never keep /login on admin.
function isAdminLushgroomHost() {
  if (typeof window === "undefined") return false;
  return String(window.location.hostname || "").toLowerCase() === "admin.lushgroom.com";
}

function isPartnerLoginRoute(to) {
  if (to.name === "login") return true;
  const path = String(to.path || "").replace(/\/+$/, "") || "/";
  if (path === "/login" || path === "/partner-login") return true;
  // Country-prefixed login, e.g. /uae/login
  return /\/[a-z][a-z-]{1,15}\/login$/i.test(path);
}

// Add router.beforeEach here
router.beforeEach((to, from, next) => {
  if (isAdminLushgroomHost() && isPartnerLoginRoute(to)) {
    window.location.replace(PARTNER_PUBLIC_LOGIN_URL);
    return next(false);
  }

  const defaultSlug = readDefaultCountrySlugFromStorage();
  const selectedCountryName = (readCountryNameFromStorage() || '').trim();

  // Prevent reserved routes (e.g. /login) from being treated as a country slug.
  // If localStorage somehow contains an invalid slug like "login", we must NOT prefix routes with it.
  const RESERVED_COUNTRY_SLUGS = new Set([
    'login',
    'partner-login',
    'partner-login-redirect',
    'booking',
    'date',
    'payment',
    'contact-us',
    'services',
    'apply-as-groomer',
    'apply-as-salon',
    'dashboard',
    'set-password',
    'privacy',
    'termscondition',
    'refundpolicy',
    'blog',
    'about',
    'about-us',
    'backhome',
  ]);

  const isValidCountrySlug = (slug) => {
    const s = String(slug || '').toLowerCase().trim();
    if (!s) return false;
    if (RESERVED_COUNTRY_SLUGS.has(s)) return false;
    // conservative: allow letters and dashes only
    if (!/^[a-z][a-z-]{1,15}$/i.test(s)) return false;
    return true;
  };

  const replaceDubai = (s) => {
    if (!s || !selectedCountryName) return s;
    return String(s).replace(/dubai/gi, selectedCountryName);
  };

  // If route is prefixed, persist current country from URL.
  if (to.params?.countrySlug) {
    const slug = String(to.params.countrySlug).toLowerCase();
    if (isValidCountrySlug(slug)) {
      setCurrentCountrySlug(slug);
    }

    // If the prefixed route is the default country, redirect to unprefixed (domain/...).
    if (slug === defaultSlug) {
      const full = to.fullPath || "/";
      const unprefixed = full.replace(new RegExp(`^/${slug}`, "i"), "") || "/";
      return next(unprefixed);
    }
  } else {
    // If route is NOT prefixed:
    // - keep it unprefixed for default country
    // - redirect to /{country}/... for non-default countries
    const current = readCountrySlugFromStorage();
    if (current && current !== defaultSlug && isValidCountrySlug(current)) {
      const full = to.fullPath || "/";
      const target = `/${current}${full.startsWith("/") ? "" : "/"}${full}`;
      return next(target);
    }
  }

  if (to.meta.title) {
    document.title = replaceDubai(to.meta.title);
  }

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', replaceDubai(to.meta.description || ''));
  } else {
    console.warn('Meta description tag not found!');
  }

  // Robots meta: GLOBAL noindex/nofollow (temporary)
  const shouldNoIndex = true;
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement('meta');
    robots.setAttribute('name', 'robots');
    document.head.appendChild(robots);
  }
  robots.setAttribute('content', shouldNoIndex ? 'noindex,nofollow' : 'index,follow');

  next();
});

export default router;

